import { StyledInnerPopup_Small, StyledOuterPopup } from "../../styles/components/Popup.styled";
import { useScrollLock } from "../../hooks";

interface Props{
  message:string;
}

export function LoadingPopup(props: Props) {
  // Lock scrolling when modal is open
  useScrollLock(true);

  return (
    <StyledOuterPopup>
      <StyledInnerPopup_Small>
        <Loading message= {props.message} />
      </StyledInnerPopup_Small>
    </StyledOuterPopup>
  );
}

function Loading(props: Props) {
  return (
    <div>
      {props.message}
    </div>
  );
}
